import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { NgxSelectModule } from 'ngx-select-ex';
import { MicrositeComponent } from './microsite.component';
import { TranslatePipeModule} from '../translate/translate.pipe.module';
import {PaginationModule} from '../project/pagination/pagination.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSelectModule,
    NgxSelectModule,
    TranslatePipeModule,
    PaginationModule,
  ],
  declarations: [MicrositeComponent],
  providers: [],
  exports: [MicrositeComponent]
})

export class MicrositeModule {

}
